"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _clientAwsS = require("@devsta/client-aws-s3");

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _ShareType = _interopRequireDefault(require("./ShareType"));

var _ShareNow = _interopRequireDefault(require("./ShareNow"));

var _LoadingIntegrations = _interopRequireDefault(require("./LoadingIntegrations"));

var _LoadingShareAccounts = _interopRequireDefault(require("./LoadingShareAccounts"));

require("../styles/_share-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ORG_SHARE_TYPE = 'ORGANISATION';
var TEAM_SHARE_TYPE = 'TEAM';
var INTEGRATION_TYPES = [// TODO: https://shootsta.atlassian.net/browse/HUB-2037 - uncomment this when share APIs will be ready
// { icon: 'youtube', type: 'YOUTUBE' },
// { icon: 'wistia', type: 'WISTIA' },
{
  icon: 'brightcove',
  type: 'BRIGHTCOVE',
  label: 'Brightcove'
} // { icon: 'facebook2', type: 'FACEBOOK' },
// { icon: 'twitter2', type: 'TWITTER' }
];

function getTeamIntegrationSettings(selectedTeamId, teamAccounts) {
  var _ref = Object.entries(teamAccounts).find(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        teamId = _ref4[0];

    return teamId === selectedTeamId;
  }) || [],
      _ref2 = _slicedToArray(_ref, 2),
      integrationSettings = _ref2[1];

  return integrationSettings;
}

function generateAccounts(orgShareSettings, teamShareSettings, organisation, teams) {
  return [{
    label: organisation.name,
    value: {
      type: ORG_SHARE_TYPE,
      id: organisation.organisationId,
      settings: orgShareSettings
    },
    prefix: /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
      placeholderText: organisation.name,
      placeholderTextSize: 12,
      imageUrl: organisation.imageUrl,
      width: "30px",
      height: "30px"
    })
  }].concat(_toConsumableArray(teams.map(function (team) {
    var settings = getTeamIntegrationSettings(team.teamId, teamShareSettings);

    if (!settings) {
      return null;
    }

    return {
      label: team.name,
      value: {
        type: TEAM_SHARE_TYPE,
        id: team.teamId,
        settings: settings
      },
      prefix: /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
        placeholderText: team.name,
        placeholderTextSize: 12,
        imageUrl: team.imageUrl,
        width: "30px",
        height: "30px"
      })
    };
  }).filter(Boolean)));
}

var ShareModal = /*#__PURE__*/function (_Component) {
  _inherits(ShareModal, _Component);

  var _super = _createSuper(ShareModal);

  function ShareModal() {
    var _this;

    _classCallCheck(this, ShareModal);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onSelectAccount", function (selectedAccount) {
      _this.setState({
        currentAccount: selectedAccount
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchShareAccounts", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getShareAccounts, getUserTeams, organisationId, organisation, apiClient, _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, shareData, shareError, _yield$Promise$all2$2, teamsData, teamsError, orgWithImage, teamsWithImage, _yield$Promise$all3, _yield$Promise$all4, orgShareAccounts, teamShareAccounts, accounts;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getShareAccounts = _this$props.getShareAccounts, getUserTeams = _this$props.getUserTeams, organisationId = _this$props.organisationId, organisation = _this$props.organisation, apiClient = _this$props.apiClient;
              _context.next = 3;
              return Promise.all([getShareAccounts(organisationId), getUserTeams(organisationId)]);

            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              _yield$Promise$all2$ = _yield$Promise$all2[0];
              shareData = _yield$Promise$all2$.data;
              shareError = _yield$Promise$all2$.error;
              _yield$Promise$all2$2 = _yield$Promise$all2[1];
              teamsData = _yield$Promise$all2$2.data;
              teamsError = _yield$Promise$all2$2.error;

              if (!(shareError || teamsError || !shareData || !shareData.getShareAccounts || !teamsData || !teamsData.getUserTeams)) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: true
              }));

            case 13:
              orgWithImage = organisation;
              teamsWithImage = teamsData.getUserTeams.map(function (team) {
                return _objectSpread(_objectSpread({}, team), {}, {
                  imageUrl: void 0
                });
              });
              _context.prev = 15;
              _context.next = 18;
              return Promise.all([(0, _clientAwsS.replaceBucketKeysWithUrls)({
                apiClient: apiClient,
                data: organisation,
                substitutedKeys: ['imageUrl'],
                organisationId: organisationId
              }), (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                apiClient: apiClient,
                dataArray: teamsWithImage,
                substitutedKeys: ['imageUrl'],
                organisationId: organisationId
              })]);

            case 18:
              _yield$Promise$all3 = _context.sent;
              _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
              orgWithImage = _yield$Promise$all4[0];
              teamsWithImage = _yield$Promise$all4[1];
              _context.next = 26;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](15);

            case 26:
              orgShareAccounts = JSON.parse(shareData.getShareAccounts.organisation);
              teamShareAccounts = JSON.parse(shareData.getShareAccounts.teams);
              accounts = generateAccounts(orgShareAccounts, teamShareAccounts, orgWithImage, teamsWithImage);

              _this.setState({
                shareAccounts: accounts,
                currentAccount: accounts[0]
              });

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[15, 24]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "onShare", (0, _lodash.default)(function (shareArgs) {
      return function () {
        _this.setState({
          shareNow: shareArgs,
          shareTags: ''
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onCancelShare", function () {
      _this.setState({
        shareNow: void 0,
        shareTags: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateTags", function (tags) {
      _this.setState({
        shareTags: tags
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onShareToProvider", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$state, shareNow, currentAccount, shareTags, _this$props2, video, shareVideo, organisationId, _yield$shareVideo, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state = _this.state, shareNow = _this$state.shareNow, currentAccount = _this$state.currentAccount, shareTags = _this$state.shareTags;

              if (!(!shareNow || !currentAccount)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              _this$props2 = _this.props, video = _this$props2.video, shareVideo = _this$props2.shareVideo;
              organisationId = video.organisationId;
              _context2.next = 7;
              return shareVideo({
                type: shareNow.type,
                organisationId: organisationId,
                teamId: currentAccount.value.type === TEAM_SHARE_TYPE ? currentAccount.value.id : null,
                tags: shareTags ? shareTags.toLowerCase().split(',') : null
              });

            case 7:
              _yield$shareVideo = _context2.sent;
              data = _yield$shareVideo.data;
              error = _yield$shareVideo.error;

              if (!(error || !data || !data.shareVideo)) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return");

            case 12:
              _this.onClose();

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      _this.setState({
        shareTags: ''
      }, function () {
        var onClose = _this.props.onClose;
        onClose();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderModalChildren", function () {
      var _this$state2 = _this.state,
          shareAccounts = _this$state2.shareAccounts,
          currentAccount = _this$state2.currentAccount,
          shareNow = _this$state2.shareNow,
          shareTags = _this$state2.shareTags,
          error = _this$state2.error;
      var onClose = _this.props.onClose;

      if (error) {
        return /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
          danger: true,
          className: "share-video-modal__error"
        }, "Something went wrong. Try closing and reopening the window.");
      }

      return shareNow ? /*#__PURE__*/_react.default.createElement(_ShareNow.default, {
        shareTags: shareTags,
        onUpdateTags: _this.onUpdateTags
      }) : /*#__PURE__*/_react.default.createElement("div", {
        className: "share-video-modal__content"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading5: true
      }, "Share as:"), /*#__PURE__*/_react.default.createElement("div", {
        className: "share-video-modal__content__accounts"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        label: true
      }, 'Choose your organisation or a team\'s share settings'), shareAccounts ? /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
        className: "share-video-modal__content__accounts__dropdown",
        options: shareAccounts,
        defaultValue: currentAccount,
        fontSize: 12,
        onChange: _this.onSelectAccount,
        type: "BUTTON"
      }) : /*#__PURE__*/_react.default.createElement(_LoadingShareAccounts.default, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "share-video-modal__content__integrations"
      }, shareAccounts ? /*#__PURE__*/_react.default.createElement("div", null, INTEGRATION_TYPES.map(function (shareTypeArgs) {
        return /*#__PURE__*/_react.default.createElement(_ShareType.default, _extends({
          key: shareTypeArgs.type
        }, shareTypeArgs, {
          title: shareTypeArgs.label,
          onClose: onClose,
          accountId: (0, _lodash2.default)(currentAccount, "value.settings.".concat(shareTypeArgs.type, ".accountId")),
          onShare: _this.onShare(shareTypeArgs)
        }));
      })) : /*#__PURE__*/_react.default.createElement(_LoadingIntegrations.default, null)));
    });

    _this.state = {
      shareTags: ''
    };
    return _this;
  }

  _createClass(ShareModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchShareAccounts();
    }
  }, {
    key: "render",
    value: function render() {
      var visible = this.props.visible;
      var shareNow = this.state.shareNow;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('share-video-modal', {
          'share-video-modal--share-now': shareNow
        })
      }, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
        visible: visible,
        title: shareNow ? "Share Via ".concat(shareNow.label) : 'Share Video',
        subtitle: shareNow ? 'Use any predefined tags and/or add your own custom tags to this video' : '',
        onClose: shareNow ? this.onCancelShare : this.onClose,
        saveText: shareNow ? 'Share Now' : void 0,
        onSave: shareNow ? this.onShareToProvider : void 0,
        closeText: shareNow ? 'Back To Sharing' : 'Cancel',
        stayOpenOnSave: true
      }, this.renderModalChildren()));
    }
  }]);

  return ShareModal;
}(_react.Component);

exports.default = ShareModal;